export const evaluationByActivity = (state) => (id) => {
	return state.evaluations.find(evaluation => evaluation.activityId === id)
}

export const evaluations = (state) => state.evaluations

export const evaluationIndex = (state) => (id) => {
	return state.evaluations.findIndex(evaluation => evaluation.activityId === id)
}